import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Hay un proveedor de SAINT® cerca de mí?",
    answer:
      "SAINT® se administra en clínicas verificadas con el sistema Magnus. Neuro Wellness TMS Centers of America en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este. Si no reside cerca, puede que necesite viajar para la semana de tratamiento.",
  },
  {
    question: "¿Cómo encuentro un proveedor verificado de SAINT®?",
    answer:
      "SAINT® se administra con el sistema de neuromodulación Magnus. Las clínicas verificadas cuentan con este equipo y con personal formado. Neuro Wellness en Coral Springs es un proveedor verificado en la Costa Este.",
  },
];

export const esSaintNearMe = makeEsArticle({
  slug: "saint-tms-near-me",
  title: "SAINT® TMS cerca de mí",
  description:
    "¿Hay un proveedor de SAINT® cerca de mí? Neuro Wellness en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este. Algunos pacientes viajan desde otros estados.",
  h1: "SAINT® TMS cerca de mí",
  breadcrumbLabel: "SAINT® cerca de mí",
  shortAnswer:
    "SAINT® se administra en clínicas verificadas con el sistema de neuromodulación Magnus. Neuro Wellness TMS Centers of America en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este. Si no reside cerca de Coral Springs, puede que necesite viajar para la semana de tratamiento de cinco días. Los aeropuertos cercanos son FLL, PBI y MIA.",
  keyTakeaways: [
    "SAINT® se administra en clínicas verificadas con el sistema Magnus.",
    "Neuro Wellness en Coral Springs es un proveedor verificado en la Costa Este.",
    "Algunos pacientes viajan desde otros estados.",
    "SAINT® se administra durante cinco días.",
    "Los aeropuertos cercanos son FLL, PBI y MIA.",
  ],
  sections: [
    {
      heading: "Proveedores verificados de SAINT®",
      paragraphs: [
        "SAINT® se administra con el sistema de neuromodulación Magnus. Las clínicas verificadas cuentan con este equipo y con personal formado en el protocolo. Neuro Wellness en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este.",
      ],
    },
    {
      heading: "Si no vive cerca",
      paragraphs: [
        "SAINT® se administra durante cinco días consecutivos. Si no reside cerca de Coral Springs, puede que necesite desplazarse y alojarse durante la semana de tratamiento. [[Viajar para SAINT®|/es/saint-tms-travel]] ofrece más información sobre aeropuertos y alojamiento.",
      ],
    },
    {
      heading: "Cómo empezar",
      paragraphs: [
        "El primer paso es una consulta con nuestro equipo clínico para confirmar la elegibilidad. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
